import axios, {AxiosError, AxiosResponse} from 'axios';
import {ErrorObject} from 'types';
import {RecipeObject} from '../types';

/**
 * Edit the recipe in the store.
 * @param {RecipeObject} exercise
 * @return {Promise<RecipeObject | ErrorObject | undefined>}
 */
export async function editRecipe(exercise: RecipeObject) {
  return axios({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_BASE_URL}/recipes`,
    data: JSON.stringify(exercise),
  }).then((response: AxiosResponse<RecipeObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
